import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  key: 1,
  class: "file-list is-light hide-scrollbar disable-overscroll-y"
};
const _hoisted_3 = {
  class: "loading-more"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "qh-icon-loading-small"
}, null, -1);
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  key: 2,
  class: "loading"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "qh-icon-loading-small"
}, null, -1);
const _hoisted_8 = [_hoisted_7];
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import FileTab from '@remote/components/FileTabPlus.vue';
import FileItem from '@remote/components/FileItem.vue';
import Footer from '@remote/components/Footer.vue';
import Fail from '@remote/components/Fail.vue';
import Empty from '@remote/components/Empty.vue';
import VipTryOut from '@remote/components/VipTryOut.vue';
import DownloadUnavailable from '@remote/components/DownloadUnavailable.vue';
import { STAND_AUTH_PROCESS_PATH_ENV, Title } from '@remote/constant';
import { useAuth } from '@remote/composable/auth';
import { useEnvStore } from '@remote/store/env';
import FloatingBird from '@remote/components/FloatingBird.vue';
import { router } from '@remote/router';
import { useHighSpeedFlow } from '@shared/composable/flow';
import { getFlowInfo } from '@remote/api/flow';
import RemoteDownloadGuide from '@remote/components/RemoteDownloadGuide.vue';
import { SECOND } from '@shared/constants/time';
import { useDeviceStore } from '@remote/store/device';
import { stat } from '@remote/utils/stat';
import { platformPath } from '@remote/platform';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useStore();
    const deviceStore = useDeviceStore();
    const action = computed(() => {
      return store.state.action;
    });
    const status = computed(() => {
      var _deviceStore$currentD;
      return ((_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.runnerTaskRef.phase) === 'PHASE_TYPE_RUNNING';
    });
    const curTaskList = computed(() => {
      return store.getters.curList;
    });
    const labels = computed(() => {
      var _deviceStore$currentD2, _deviceStore$currentD3;
      return (_deviceStore$currentD2 = (_deviceStore$currentD3 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD3 === void 0 ? void 0 : _deviceStore$currentD3.deviceInfoRef.labels) !== null && _deviceStore$currentD2 !== void 0 ? _deviceStore$currentD2 : [];
    });
    const isDownloadAvailable = computed(() => {
      return store.getters.isDownloadAvailable;
    });
    const isRemoteDownloadGuideShow = ref(false);
    const envStore = useEnvStore();
    const shouldRemoteDownloadGuideShow = computed(() => {
      // 请求过runner且确实没有runner，且环境是 Mac迅雷 / Android迅雷  / iOS迅雷
      // 需求文档 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105298964
      return store.state.haveRequestedRunner // 请求过runner
      && deviceStore.deviceMap.size === 0 // 确实没有runner
      && !envStore.isInPC // 不在PC中
      && platformPath === ''; // 非厂商环境
    });
    // 首页展示什么
    const currentShowContent = computed(() => {
      // 未请求runner时
      if (!store.state.haveRequestedRunner) {
        // 需要Fail组件来展示连接中，后续可能把fail里面的connecting状态拆出来比较好
        return 'fail';
      } else {
        // 请求完runner
        if (isRemoteDownloadGuideShow.value) {
          // 没有runner的时候展示，因为存在没有runner变成有runner，仍然要展示的逻辑
          // 所以它优先级最高
          return 'remote-download-guide';
        } else if (!isDownloadAvailable.value) {
          return 'download-unavailable';
        } else {
          var _deviceStore$currentD4;
          if (((_deviceStore$currentD4 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD4 === void 0 ? void 0 : _deviceStore$currentD4.runnerTaskRef.phase) === 'PHASE_TYPE_RUNNING') {
            // 当前runner是否连接正常
            return 'task';
          } else {
            return 'fail';
          }
        }
      }
    });
    watch(shouldRemoteDownloadGuideShow, (newVal, oldVal) => {
      if (newVal) {
        isRemoteDownloadGuideShow.value = true;
      }
    }, {
      immediate: true
    });
    const finishStartXLLite = () => {
      setTimeout(() => {
        isRemoteDownloadGuideShow.value = false;
      }, 3 * SECOND);
    };
    const isFloatBirdShow = computed(() => {
      return store.state.taskType === 'ing' && currentShowContent.value === 'task' && labels.value.includes('withHighSpeedFlowCtrl');
    });
    const curRunningTaskList = computed(() => {
      return store.getters.curList.map(id => store.state.all[id]).filter(i => i.phase === 'PHASE_TYPE_RUNNING');
    });
    const curPausedTaskList = computed(() => {
      return store.getters.curList.map(id => store.state.all[id]).filter(i => i.phase === 'PHASE_TYPE_PAUSED');
    });
    const taskType = computed(() => {
      return store.state.taskType;
    });
    const firstLoad = computed(() => {
      return store.state.firstLoadTasks[store.state.taskType];
    });
    const {
      remainFlow
    } = useHighSpeedFlow({
      getFlowInfo
    });
    watch(action, async val => {
      if (val === 'close') {
        store.dispatch('close');
      } else if (val === 'tip-guide') {
        store.commit('dialog', {
          show: false
        });
      } else if (val === 'deviceControl') {
        store.commit('dialog', {
          show: false
        });
        console.log('deviceControl - ', store.state.platform);
        /**
         * 判断厂商是否支持从远程登出设备上的登录态；
         * 如果不支持，只能让用户登出Remote端的登录态，client端登录态要从套件退出或者由厂商侧退出。
         */
        const {
          pathEnv
        } = useEnvStore();
        if (STAND_AUTH_PROCESS_PATH_ENV.includes(pathEnv)) {
          const {
            signOut
          } = useAuth();
          signOut();
          await store.dispatch('logout', true);
        } else {
          await store.dispatch('getRunner');
          router.push({
            path: '/me/',
            query: router.currentRoute.value.query
          });
        }
      }
    });
    watch(status, val => {
      if (val) {
        // 如果有下载链接就跳转到upload
        const query = router.currentRoute.value.query;
        if (query.taskLink) {
          const taskLink = query.taskLink;
          delete query.taskLink;
          router.push({
            path: '/upload/',
            query: {
              taskLink,
              ...query
            }
          });
          setTimeout(() => {
            router.push({
              path: router.currentRoute.value.path,
              query
            });
          }, 1000);
        }
      }
    });
    onMounted(async () => {
      document.title = Title;
      // openPopHighSpeedFlowPurchase({})
      let huddleTime = localStorage.getItem('huddleTime') || '';
      let huddleNum = Number(localStorage.getItem('huddleNum') || '3');
      if (huddleTime !== store.state.today) {
        huddleTime = store.state.today;
        localStorage.setItem('huddleTime', huddleTime);
        huddleNum = 3;
        localStorage.setItem('huddleNum', String(huddleNum));
      }
      store.commit('update', {
        huddleTime
      });
    });
    const loadMore = () => {
      if (store.state.loading) return;
      store.dispatch('getTasks', {
        page_token: store.state.nextPageToken,
        type: store.state.taskType
      });
    };
    return (_ctx, _cache) => {
      const _directive_observer = _resolveDirective("observer");
      const _directive_see = _resolveDirective("see");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [['fail', 'task'].includes(currentShowContent.value) ? (_openBlock(), _createBlock(FileTab, {
        key: 0
      })) : _createCommentVNode("", true), ['fail', 'task'].includes(currentShowContent.value) ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curTaskList.value, id => {
        return _openBlock(), _createBlock(FileItem, {
          id: id,
          key: id
        }, null, 8, ["id"]);
      }), 128))]), _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_3, _hoisted_5)), [[_vShow, _unref(store).state.nextPageToken], [_directive_observer, {
        show: loadMore
      }]])], 512)), [[_vShow, curTaskList.value.length > 0 && status.value]]) : _createCommentVNode("", true), ['fail', 'task'].includes(currentShowContent.value) ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_6, _hoisted_8, 512)), [[_vShow, curTaskList.value.length === 0 && firstLoad.value && status.value]]) : _createCommentVNode("", true), ['fail'].includes(currentShowContent.value) ? (_openBlock(), _createBlock(Fail, {
        key: 3
      })) : _createCommentVNode("", true), ['task'].includes(currentShowContent.value) && curTaskList.value.length === 0 && !firstLoad.value && taskType.value !== 'file' ? (_openBlock(), _createBlock(Empty, {
        key: 4
      })) : _createCommentVNode("", true), currentShowContent.value === 'download-unavailable' ? (_openBlock(), _createBlock(DownloadUnavailable, {
        key: 5
      })) : _createCommentVNode("", true), currentShowContent.value === 'remote-download-guide' ? _withDirectives((_openBlock(), _createBlock(RemoteDownloadGuide, {
        key: 6,
        onDone: finishStartXLLite,
        from: "download_no_device"
      }, null, 512)), [[_directive_see, () => _unref(stat)({
        action: 'download_remote_avalible_page_show'
      })]]) : _createCommentVNode("", true), status.value && taskType.value === 'ing' && curTaskList.value.length && _unref(store).getters.runnerConfig ? (_openBlock(), _createBlock(VipTryOut, {
        key: 7
      })) : _createCommentVNode("", true), _unref(store).state.isSelect ? (_openBlock(), _createBlock(Footer, {
        key: 8
      })) : _createCommentVNode("", true), _withDirectives(_createVNode(FloatingBird, {
        "running-task-list": curRunningTaskList.value,
        "paused-task-list": curPausedTaskList.value
      }, null, 8, ["running-task-list", "paused-task-list"]), [[_vShow, isFloatBirdShow.value]])]);
    };
  }
});